import { graphql } from '../../graphql/generated';

export const LAB_QUERY = graphql(`
  query Lab($id: ID!) {
    lab(id: $id) {
      id
      name
      shortName
      longName
    }
  }
`);

export const COMPILE_PARAMS_MUTATION = graphql(`
  mutation CompileParams {
    compileParams
  }
`);
